const publicUrl = process.env.PUBLIC_URL || "";

/** Prefix a public-folder path with CRA's PUBLIC_URL (e.g. /app for subpath deploys). */
export const withPublicUrl = (path) =>
  `${publicUrl}${path.startsWith("/") ? path : `/${path}`}`;
